import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote2 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCE 2025</h1>
              <h6>The 2025 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (CSCE)</h6>
              <h6>July 21-24, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>


          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>The Future is Integrated: Predictive Intelligence for Semiconductor Supply Chains</b> <br/>
            Deepshikha Shekhawat <br/>
            Business Intelligence Program Manager, AMD, Inc. <br />
            Affiliated with Fortune 500 Companies, including AMD and Applied Materials.<br />
            </div>

            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            In the fast-paced semiconductor industry, fragmented data across teams hampers efficiency and decision-making. This session explores how to break down these silos using smart data architecture and predictive analytics to streamline supply chains and reduce time-to-market. Drawing from 12+ years of experience, I’ll share real-world strategies to unify critical data, define effective KPIs, and enable real-time insights into supplier performance, lead times, and costs. Attendees will gain actionable guidance on building robust, cross-functional data infrastructure that enhances forecasting, boosts transparency, and empowers all levels of the organization to make faster, data-driven decisions that drive measurable business outcomes.
            </div>

            <h6 className="par_header">Speaker’s Biography:</h6>
            <div className="par">
            IEEE Senior Member and data strategy speaker at renowned conferences, Deepshikha is a recognized expert in semiconductor supply chain operations, manufacturing, and business intelligence. She has driven major efficiencies through strategic automation, data architecture, and visualization—reducing manual reporting, cutting component search time, and accelerating product development. Her predictive analytics initiatives have delivered 5–10% procurement savings and inventory waste reduction. With experience at Fortune 500 companies like AMD and Applied Materials, her leadership in business continuity, supplier performance, and operational data integration has transformed decision-making across the semiconductor industry into a real-time, insight-driven process.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/Shekhawat.jpg" height="300px" alt=""/>
            </div>
            </div>


          </div>


        </div>
      </div>
    );
  }
}

export default Keynote2;